export default __webpack_public_path__ + "static/media/todolistshort.ff8462c5.jpg";